import React from "react";

const items = [
  "Live Music & Orchestra",
  "Dancers · Aerial · Fire Show",
  "Thematic Worlds",
  "Integrated Production",
  "Lighting & Technique",
  "Bespoke Concepts",
];

/** Infinite horizontal marquee — luxury service ticker inspired by editorial fashion runs. */
export default function Marquee() {
  const track = [...items, ...items, ...items];
  return (
    <section
      aria-label="Services ticker"
      className="relative bg-[var(--lu-black)] border-y border-[var(--lu-gold)]/30 py-6 overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="marquee-track flex items-center whitespace-nowrap gap-14">
        {track.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-14 font-serif text-[22px] sm:text-[28px] text-[var(--lu-ivory)] italic"
            data-testid={`marquee-item-${i % items.length}`}
          >
            {t}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--lu-gold)" aria-hidden>
              <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" />
            </svg>
          </span>
        ))}
      </div>
    </section>
  );
}
